import React, { lazy } from 'react';
import { MapPin } from 'lucide-react';
export function MapLocation() {
  return <section className="py-20 bg-gray-50" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-271">
          {/* Google Maps Embed */}
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3587.4982738295847!2d-80.15566492378396!3d25.948826577342567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9ac1f3f3f3f3f%3A0x3f3f3f3f3f3f3f3f!2s390%20NE%20191st%20St%2C%20Miami%2C%20FL%2033179!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" width="100%" height="500" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Brixen Funding Location" data-id="element-272"></iframe>

          {/* Logo Overlay - Moved to Right Side */}
          <div className="absolute top-8 right-8 bg-white p-6 rounded-xl shadow-2xl border border-gray-100 max-w-xs" data-id="element-273">
            <img src="https://cdn.magicpatterns.com/uploads/oxFWMvdwUBRjCt1riBg7DA/Asset_44x.png" alt="Brixen Funding" className="h-10 w-auto mb-4" data-id="element-274" />
            <div className="flex items-start text-left" data-id="element-275">
              <MapPin className="w-5 h-5 text-[#00E676] mr-3 mt-1 flex-shrink-0" data-id="element-276" />
              <div data-id="element-277">
                <p className="text-sm font-bold text-gray-900 mb-1" data-id="element-278">
                  Company Address
                </p>
                <p className="text-sm text-gray-600" data-id="element-279">
                  390 NE 191ST ST
                  <br data-id="element-280" />
                  Miami, FL 33179
                </p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-281">
              <p className="text-xs text-gray-500 mb-2" data-id="element-282">Talk To Us</p>
              <p className="text-sm font-semibold text-gray-900" data-id="element-283">
                (786) 272-6132
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}